
import api from '@/store/api'
import { updateField } from 'vuex-map-fields'

export const state = {
	cancelLoading: false
}

export const mutations = {
	updateField
}

export const actions = {
	async cancelUpload ({ state }, payload) {
		state.cancelLoading = true
		await api('post', 'cancel-upload', payload)
		state.cancelLoading = false
	}
}
